import React from "react";
import { DashboardPageLayout } from "../../../components/layout/DashboardPageLayout";
import { ButtonLink } from "../../../components/ui/button";
import { Card, CardContent } from "../../../components/ui/card";
import { WebsiteSetupFormFields } from "./WebsiteSetupForm";
import type { MainAppPageProps } from "../types";

type WebsiteSetupPageProps = Pick<
  MainAppPageProps,
  "csrfToken" | "routes" | "websiteForm"
>;

export const WebsiteSetupPage: React.FC<WebsiteSetupPageProps> = ({
  csrfToken,
  routes,
  websiteForm,
}) => {
  return (
    <DashboardPageLayout
      title="Create your website"
      subtitle="Add where you work. ToolKit uses your company name, phone, and trade from setup."
      headerActions={
        routes.dashboard ? (
          <ButtonLink to={routes.dashboard} variant="outline">
            Back to products
          </ButtonLink>
        ) : null
      }
    >
      <Card className="bg-card">
        <CardContent className="pt-6">
          <WebsiteSetupFormFields
            csrfToken={csrfToken}
            routes={routes}
            websiteForm={websiteForm}
          />
        </CardContent>
      </Card>
    </DashboardPageLayout>
  );
};
